import Navbar from "./Navbar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#FCFBF8]">
      <Navbar />
      <main>{children}</main>
      <footer className="border-t border-[#EAE6DF] mt-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 text-sm text-[#8a968f] flex flex-col md:flex-row justify-between gap-3">
          <div>© {new Date().getFullYear()} Mosquée des Alpes · Grenoble · Association loi 1901</div>
          <div className="text-xs uppercase tracking-[0.2em]">Cours d'Arabe · Coran · Éducation Musulmane</div>
        </div>
      </footer>
    </div>
  );
}
